var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArchive = function SvgArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.16 2.423a.5.5 0 0 1-.416.571L3.41 5.077a.5.5 0 0 1-.155-.988L16.59 2.006a.5.5 0 0 1 .57.417Zm-.157 3.457a.5.5 0 0 1 .164.37v9.25a2.5 2.5 0 0 1-2.5 2.5H5.333a2.5 2.5 0 0 1-2.5-2.5v-8a.5.5 0 0 1 .454-.498l13.333-1.25a.5.5 0 0 1 .383.128ZM3.833 7.955V15.5a1.5 1.5 0 0 0 1.5 1.5h9.334a1.5 1.5 0 0 0 1.5-1.5V6.799L3.833 7.955ZM7.5 10.75a.5.5 0 1 0 0 1h5a.5.5 0 0 0 0-1h-5Z",
    fill: "#818C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.16 2.423a.5.5 0 0 1-.416.571L3.41 5.077a.5.5 0 0 1-.155-.988L16.59 2.006a.5.5 0 0 1 .57.417Zm-.157 3.457a.5.5 0 0 1 .164.37v9.25a2.5 2.5 0 0 1-2.5 2.5H5.333a2.5 2.5 0 0 1-2.5-2.5v-8a.5.5 0 0 1 .454-.498l13.333-1.25a.5.5 0 0 1 .383.128ZM3.833 7.955V15.5a1.5 1.5 0 0 0 1.5 1.5h9.334a1.5 1.5 0 0 0 1.5-1.5V6.799L3.833 7.955ZM7.5 10.75a.5.5 0 1 0 0 1h5a.5.5 0 0 0 0-1h-5Z",
    fill: "#747F88"
  })));
};

export default SvgArchive;